<template>

    <div class="d-flex w-100 align-items-center">
        <div class="col-md-3 px-0">
            <checkbox name="allotment" class="" v-model="deliverNotification" value="1">Deliver notification</checkbox>
        </div>
        <div class="col-md-9 text-right">
            <span class="font-weight-600 pointer color-6" :disabled="getIsUpdatingEvent" @click="deleteEvent">Delete</span>
            <button class="btn tertiary px-5" :disabled="getIsUpdatingEvent"@click="cancelEdit">Cancel</button>
            <button class="btn success px-5" :disabled="validations.$invalid || getIsUpdatingEvent || isCreatingEvent" @click="saveChanges(false)">Save</button>
            <button class="btn success px-5" :disabled="validations.$invalid || getIsUpdatingEvent || isCreatingEvent" @click="saveChanges(true)" v-if="getIsCreatSingleEvent">Save & Book</button>
        </div>
    </div>

</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import {eventHub} from '../../../main'

    import mixpanelMixin from '@/mixins/mixpanel'

    export default {
        mixins: [
            mixpanelMixin
        ],
        props: {
            validations: {
                type: Object
            }
        },
        data: function() {
            return {
                deliverNotification: false,
                isCreatingEvent: false
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent',
                'account',
                'getIsCreatSingleEvent',
                'getIsUpdatingEvent'
            ])
        },
        methods: {
            ...mapActions([
                'saveEventChanges',
                'closeModal',
                'setModalConfirmData',
                'openModal',
                'flushEvents',
                'downloadEvents',
                'setReservationSelectedEvent',
                'setReservationSelectedProduct',
                'downloadSingleEvent',
                'updateSelectedEvent',
            ]),
            saveChanges: function(saveAndBook){
                if(!this.getIsCreatSingleEvent){
                    //is updating existing event
                    if (this.getSelectedEvent.setToCancel) {

                        let vm = this;
                        let message = '<strong>'+this.getSelectedEvent.product.name+'</strong> status will be set as <span class="color-6">canceled</span>.<br>Future bookings will be blocked for this event.';

                        this.$dialog.confirm(message)
                        .then(function () {
                            vm.submitToApiUpdate();
                            vm.closeModal()

                        })
                        .catch(function () {
                            // console.log('Clicked on cancel')
                        });
                    } else {
                        this.submitToApiUpdate();
                    }
                } else {
                    //is creating new single event

                    if(this.getSelectedEvent.product == null){
                        let vm = this;
                        let message = 'In order to create the event you must selected a product on "Date / Location".';

                        this.$dialog.alert(message)
                        .then(function () {
                            return false
                        })
                    } else {
                        this.isCreatingEvent = true
                        axios.post('/api/event/create', {
                            supplierId: this.account.supplierId,
                            productId: this.getSelectedEvent.product.id,
                            event: this.getSelectedEvent
                        }).then(response => {
                            this.isCreatingEvent = false
                            if(saveAndBook){

                                axios.get('/api/calendar/GetEvents', {
                                    params: {
                                        supplierId: this.account.supplierId,
                                        eventId: response.data.id
                                    }
                                }).then(response2 => {
                                    this.setReservationSelectedEvent(response2.data.events[0]);
                                    this.setReservationSelectedProduct(response2.data.events[0].product);
                                    this.$router.push('/reservation/resume');

                                })


                            }

                            let dateToUpdate = response.data.start.split(" ")[0]
                            this.closeModal()
                            eventHub.$emit('updateCalendar', dateToUpdate);
                        }).catch(error => {
                            this.isCreatingEvent = false
                        })
                    }
                }
            },
            submitToApiUpdate: function(){
                let data = {
                    supplierId: this.account.supplierId,
                    deliverNotification: this.deliverNotification
                }
                this.trackSaveChanges('Event', this.getSelectedEvent.id, this.getSelectedEvent.product.name)
                this.saveEventChanges(data).then( response => {
                    console.log(response);

                    //remove the edited event from calendar (in case for example the durantion changes)
                    this.downloadSingleEvent(response.data.id).then(response => {
                        console.log('updated event', response);
                        // update the selected event
                        this.updateSelectedEvent(response.data.events[0])

                        // request calendar to refresh
                        this.eventHub.$emit('updateCalendar');
                    })

                    this.$toasted.info('Updating calendar to show recent changes');


                    // try {
                    //     let dateToUpdate = response.data.start.split(" ")[0]
                    //     eventHub.$emit('updateCalendar', dateToUpdate);
                    // } catch (error){
                    // }
                });
            },
            deleteEvent: function(){
                let vm = this;
                let message = 'Delete this event will remove all content related with it<br>(reservations, details and reports data). <br>This can not be undone.';

                this.$dialog.confirm(message)
                .then(function () {
                    axios.post('/api/calendar/deleteEvent', {
                        supplierId: vm.account.supplierId,
                        event: vm.getSelectedEvent,
                        deliverNotification: vm.deliverNotification
                    }).then(function(response){
                        if(response.status === 200){
                            vm.flushEvents();
                            let dateToUpdate = vm.getSelectedEvent.start.split(" ")[0]
                            eventHub.$emit('updateCalendar', dateToUpdate);
                            vm.eventHub.$emit('closeCalendarEventDetails');
                            vm.closeModal();
                        }
                    }).catch(function(err){
                        console.log(err);
                    })
                })
                .catch(function () {
                    console.log('Clicked on cancel')
                });

            },
            cancelEdit: function() {
                this.$emit('cancelEdit');
            }

        },
        components: {
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// footerButtons.vue?36adb708